/**
 * @generated SignedSource<<f634053c373aa0f63ffc508fe5b2b9ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DescoperTaskStatus = "FAILURE" | "NOT_FOUND" | "PENDING" | "RUNNING" | "SUCCESS" | "%future added value";
export type InternBrandOnboardingGetDescoperTaskStatusQuery$variables = {
  taskKey: string;
};
export type InternBrandOnboardingGetDescoperTaskStatusQuery$data = {
  readonly descoperTaskStatus: {
    readonly currentStep: string;
    readonly error: string | null;
    readonly message: string;
    readonly progress: number;
    readonly result: {
      readonly error: string | null;
      readonly initialScreenshot: {
        readonly bottomScreenshotUrl: string;
        readonly topScreenshotUrl: string;
      };
      readonly invalidated: ReadonlyArray<{
        readonly confidence: number;
        readonly height: number;
        readonly reasons: ReadonlyArray<string>;
        readonly selector: string;
        readonly type: string;
        readonly width: number;
        readonly x: number;
        readonly y: number;
      }>;
      readonly pageUrl: string;
      readonly validated: ReadonlyArray<{
        readonly confidence: number;
        readonly height: number;
        readonly reasons: ReadonlyArray<string>;
        readonly selector: string;
        readonly type: string;
        readonly width: number;
        readonly x: number;
        readonly y: number;
      }>;
      readonly validationScreenshot: {
        readonly bottomScreenshotUrl: string;
        readonly topScreenshotUrl: string;
      };
    } | null;
    readonly status: DescoperTaskStatus;
  };
};
export type InternBrandOnboardingGetDescoperTaskStatusQuery = {
  response: InternBrandOnboardingGetDescoperTaskStatusQuery$data;
  variables: InternBrandOnboardingGetDescoperTaskStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskKey"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "topScreenshotUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bottomScreenshotUrl",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "selector",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "confidence",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasons",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "x",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "y",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskKey",
        "variableName": "taskKey"
      }
    ],
    "concreteType": "DescoperTaskStatusResponse",
    "kind": "LinkedField",
    "name": "descoperTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "progress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentStep",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "DescoperTaskResult",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OnboardingDescoperScreenshotBundle",
            "kind": "LinkedField",
            "name": "initialScreenshot",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OnboardingDescoperScreenshotBundle",
            "kind": "LinkedField",
            "name": "validationScreenshot",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DescoperElement",
            "kind": "LinkedField",
            "name": "validated",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DescoperElement",
            "kind": "LinkedField",
            "name": "invalidated",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandOnboardingGetDescoperTaskStatusQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandOnboardingGetDescoperTaskStatusQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8621a4b8982ac73ba69ca08ea0491894",
    "id": null,
    "metadata": {},
    "name": "InternBrandOnboardingGetDescoperTaskStatusQuery",
    "operationKind": "query",
    "text": "query InternBrandOnboardingGetDescoperTaskStatusQuery(\n  $taskKey: String!\n) {\n  descoperTaskStatus(taskKey: $taskKey) {\n    status\n    progress\n    currentStep\n    message\n    error\n    result {\n      pageUrl\n      initialScreenshot {\n        topScreenshotUrl\n        bottomScreenshotUrl\n      }\n      validationScreenshot {\n        topScreenshotUrl\n        bottomScreenshotUrl\n      }\n      validated {\n        type\n        selector\n        confidence\n        reasons\n        x\n        y\n        width\n        height\n      }\n      invalidated {\n        type\n        selector\n        confidence\n        reasons\n        x\n        y\n        width\n        height\n      }\n      error\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af3417b7470eb37827be5078f9704945";

export default node;
